<template>
    <Layout :isLogin="true">
        <div slot="epassport">
            <iframe ref="iframe" :src="IFRAME_URL"></iframe>
        </div>
    </Layout>
</template>

<script>
import { sdk } from 'data';

const IFRAME_URL = sdk('RECOVER');
export default {
    data() {
        return { IFRAME_URL };
    }
};
</script>

<style lang="scss">
.epassport {
    min-width: 640px;
    .el-dialog {
        width: 600px;
    }
}
.el-dialog__body.el-dialog__body_epassport .el-dialog-epassport {
    height: 450px;
}
</style>
